<script>
    /* БОКОВОЕ МЕНЮ ФРАКЦИИ.
       Раньше разделы жили плитками на отдельном экране: чтобы попасть из парковки
       в логи, надо было вернуться назад и снова выбрать плитку. Теперь все разделы
       видны всегда слева, текущий подсвечен — как в системных приложениях.
       Пункты показываются по правам: то, чего игроку нельзя, просто не рисуется. */
    import { executeClient, executeClientToGroup, executeClientAsyncToGroup } from 'api/rage'
    import { selectTableView, setView, setPopup, isFraction, isOrganization, ftAccess, ftTitle } from '../data'
    import { charFractionID } from 'store/chars'
    import Icon from './icon.svelte'

    export let settings = {};
    export let tableInfo = {};

    /* Меню рисуется раньше, чем родитель успевает получить данные, поэтому
       запрашиваем их и сами — иначе в шапке висит «Организация», а разделы по
       правам (война за территорию, материалы) не появляются. */
    const askSettings = () => executeClientAsyncToGroup ("getSettings").then ((result) => {
        if (result && typeof result === "string") {
            try {
                const own = JSON.parse (result);
                if (own && own.name) settings = own;
            } catch (e) { }
        }
    });
    askSettings ();
    setTimeout (askSettings, 400);
    setTimeout (askSettings, 1500);
    setTimeout (askSettings, 3000);

    let current = "Hub";
    selectTableView.subscribe (value => current = value);

    // логотип берём штатный (по id фракции), у организаций — общий
    $: logoUrl = isOrganization() || !$charFractionID
        ? document.cloud + 'img/fractionLogo/Org.png'
        : document.cloud + 'img/fractionLogo/Fraction_' + $charFractionID + '.png';

    // склад «Материалы» — только у гос. фракций (как было в старом меню)
    $: isGov = isFraction() && settings && settings.fractionId
        && [6, 7, 8, 9, 14, 15, 18].includes (settings.fractionId);
    // война за территорию — у банд
    $: isGang = isFraction() && settings && settings.id >= 1 && settings.id <= 5;

    const items = () => ([
        { id: 'Hub',      name: 'Обзор',        icon: 'home',  hint: 'Главное о фракции' },
        { id: 'Members',  name: 'Состав',       icon: 'users', hint: 'Кто во фракции' },
        { id: 'Parking',  name: 'Транспорт',    icon: 'car',   hint: 'Машины фракции' },
        { id: 'Tasks',    name: 'Задания',      icon: 'task',  hint: 'Что нужно сделать' },
        { id: 'Journal',  name: 'Журнал',       icon: 'log',   hint: 'Все действия' },
        ...(isGov ? [{ id: 'Materials', name: 'Материалы', icon: 'box', hint: 'Склад материалов' }] : []),
        // ФТ — только у руководства S.A.S.P.A: флаг ставится, когда сервер
        // ответил списком, а отвечает он лидеру и замам
        ...($ftAccess ? [{ id: 'Prison', name: $ftTitle, icon: 'shield', hint: 'Кто сейчас сидит' }] : []),
    ]);

    const manage = () => ([
        { id: 'Accesses', name: 'Ранги и права', icon: 'shield', hint: 'Кому что можно' },
        ...(isGang ? [{ id: '__capture', name: 'Война за территорию', icon: 'swords', hint: 'Карта каптов' }] : []),
    ]);

    const onOpen = (item) => {
        if (item.id === '__capture') {
            executeClient ("client.capture.openFromTablet");
            return;
        }

        setView (item.id);
    }

    const onLeave = () => {
        setPopup ("Confirm", {
            headerTitle: "Выход",
            headerIcon: "fractionsicon-members",
            text: isOrganization ()
                ? "Вы действительно хотите покинуть организацию?"
                : "Вы действительно хотите покинуть фракцию?",
            button: 'Выйти',
            callback: () => executeClientToGroup ('leave')
        })
    }
</script>

<aside class="jrnav">
    <div class="jrnav__top">
        <img class="jrnav__logo" src={logoUrl} alt=""
             onerror="this.onerror=null;this.src=document.cloud+'img/fractionLogo/Org.png'"/>
        <div class="jrnav__names">
            <p class="jrnav__title">{tableInfo.name || settings.name || 'Организация'}</p>
            <p class="jrnav__sub">
                {#if tableInfo.online !== undefined}
                    в сети {tableInfo.online} из {tableInfo.all}
                {:else}
                    состав фракции
                {/if}
            </p>
        </div>
    </div>

    <div class="jrnav__label">Разделы</div>
    <div class="jrnav__list">
        {#each items () as item}
            <div class="jrnav__item" class:on={current === item.id} title={item.hint}
                 on:keypress={() => {}} on:click={() => onOpen (item)}>
                <Icon name={item.icon}/>
                <span>{item.name}</span>
            </div>
        {/each}
    </div>

    <div class="jrnav__label">Управление</div>
    <div class="jrnav__list">
        {#each manage () as item}
            <div class="jrnav__item" class:on={current === item.id} title={item.hint}
                 on:keypress={() => {}} on:click={() => onOpen (item)}>
                <Icon name={item.icon}/>
                <span>{item.name}</span>
            </div>
        {/each}
    </div>

    <div class="jrnav__foot">
        <div class="jrnav__leave" on:keypress={() => {}} on:click={onLeave}>Покинуть организацию</div>
    </div>
</aside>
